import React, { Component } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { updateProfile } from '../actions/profileActions'; // adjust path

class LoginPageClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            errors: {},
        };
    }

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    validateForm = () => {
        const { username, password } = this.state;
        let errors = {};
        let isValid = true;

        if (!username) {
            errors.username = 'Email is required';
            isValid = false;
        } else {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(username)) {
                errors.username = 'Invalid email format';
                isValid = false;
            }
        }

        if (!password) {
            errors.password = 'Password is required';
            isValid = false;
        } else if (password.length < 6) {
            errors.password = 'Password must be at least 6 characters';
            isValid = false;
        }

        this.setState({ errors });
        return isValid;
    };

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validateForm()) {
            const { username, password } = this.state;
            const envEmail = process.env.REACT_APP_LOGIN_EMAIL;
            const envPassword = process.env.REACT_APP_LOGIN_PASSWORD;

            if (username === envEmail && password === envPassword) {
                alert('✅ Sign in successful!');
                const profile = {
                    email: username,
                    name: 'ADMIN',
                    avatarUrl: '/account.png',
                    isLoggedIn: true,
                };

                // Update Redux profile
                this.props.updateProfile(profile, true);

                localStorage.setItem('USER_DETAILS', JSON.stringify(profile));

                // Redirect using navigate prop
                this.props.navigate('/');
            } else {
                alert('❌ Invalid credentials. Please try again.');
            }
        }
    };

    render() {
        const { username, password, errors } = this.state;
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background:
                        'linear-gradient(135deg, #6EE7B7 0%, #3B82F6 100%)',
                }}
            >
                <div
                    style={{
                        width: '100%',
                        maxWidth: '400px',
                        padding: '40px',
                        borderRadius: '12px',
                        background: '#fff',
                        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
                        textAlign: 'center',
                    }}
                >
                    <h1 style={{ marginBottom: '10px', color: '#111827' }}>
                        Login
                    </h1>
                    <p style={{ marginBottom: '25px', color: '#6B7280' }}>
                        Welcome! Please enter your details.
                    </p>

                    <form onSubmit={this.handleSubmit}>
                        <input
                            type="email"
                            name="username"
                            placeholder="Email"
                            value={username}
                            onChange={this.handleChange}
                            style={{
                                width: '100%',
                                padding: '12px',
                                marginBottom: '5px',
                                border: '1px solid #d1d5db',
                                borderRadius: '8px',
                                fontSize: '14px',
                            }}
                        />
                        {errors.username && (
                            <p
                                style={{
                                    color: 'red',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                    marginBottom: '10px',
                                }}
                            >
                                {errors.username}
                            </p>
                        )}

                        <input
                            type="password"
                            name="password"
                            placeholder="Password"
                            value={password}
                            onChange={this.handleChange}
                            style={{
                                width: '100%',
                                padding: '12px',
                                marginBottom: '5px',
                                border: '1px solid #d1d5db',
                                borderRadius: '8px',
                                fontSize: '14px',
                            }}
                        />
                        {errors.password && (
                            <p
                                style={{
                                    color: 'red',
                                    fontSize: '12px',
                                    marginBottom: '10px',
                                    textAlign: 'left',
                                }}
                            >
                                {errors.password}
                            </p>
                        )}

                        <button
                            type="submit"
                            style={{
                                width: '100%',
                                padding: '12px',
                                background: '#3B82F6',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '8px',
                                fontSize: '16px',
                                cursor: 'pointer',
                                transition: 'background 0.3s ease',
                                marginTop: '10px',
                            }}
                        >
                            Login
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}

// Wrap class component in a function to provide navigate
function LoginPage(props) {
    const navigate = useNavigate();
    return <LoginPageClass {...props} navigate={navigate} />;
}

export default connect(null, { updateProfile })(LoginPage);
